import { render, staticRenderFns } from "./ActionStatic.vue?vue&type=template&id=2348035e"
import script from "./ActionStatic.vue?vue&type=script&lang=ts"
export * from "./ActionStatic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports